import { sendPost } from "./generic";
import { getAssistantApiUrl, getBaseApiUrl } from "../../constants/Urls";
import ResponseVariableReplacementRequest from "../../models/responseVariables/ResponseVariableReplacementRequest";
import ResponseVariableReplacementResponse from "../../models/responseVariables/ResponseVariableReplacementResponse";

/**
 * Performs response variable replacement on the given text using custom context data.
 * This allows testing response variable replacement without making a full assistant request.
 */
export const replaceResponseVariables = (request: ResponseVariableReplacementRequest) => {
    return sendPost<ResponseVariableReplacementResponse>(
        `/ResponseVariable/Replace`,
        request,
        getAssistantApiUrl()
    );
};

export interface GenAIChatTurn {
    role: 'assistant' | 'user';
    text: string;
}

export interface ResponseVariableAssistantChatRequest {
    applicationId: string;
    applicationSecret: string;
    conversationHistory: GenAIChatTurn[];
}

export interface ResponseVariableAssistantChatResponse {
    response: string;
}

/**
 * Sends a chat message to the response variable assistant AI.
 * The assistant has context about how to use response variables.
 */
export const chatWithResponseVariableAssistant = (request: ResponseVariableAssistantChatRequest) => {
    return sendPost<ResponseVariableAssistantChatResponse>(
        `/responseVariable/chat`,
        request,
        getAssistantApiUrl()
    );
};
